var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardPoints(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.47716 20 0 15.5229 0 9.99995C0 4.47715 4.47716 0 10 0C15.5228 0 20 4.47715 20 9.99995C20 15.5229 15.5228 20 10 20ZM10 18C14.4183 18 18 14.4183 18 9.99995C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 9.99995C2 14.4183 5.58172 18 10 18ZM10 5.05025L14.9497 9.99995L10 14.9497L5.05026 9.99995L10 5.05025ZM10 7.87868L7.87868 9.99995L10 12.1213L12.1213 9.99995L10 7.87868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardPoints);
export default __webpack_public_path__ + "static/media/rewardPoints.32143b82ebaa692fa760630d18b9ce75.svg";
export { ForwardRef as ReactComponent };